import { Record, Map } from 'immutable'
import _ from 'lodash'

import {
    INITIALIZE_GROUP_MONITORING_DIALOG,
    GROUP_MONITORING_DATA_REQUEST_SUCCESS,
    UPDATE_GROUP_MONITORING_REQUEST_SUCCESS,
    UPDATE_GROUP_MONITORING_REQUEST,
} from './constants'

const InitialGroupMonitoringState = Record({
    loading: false,
    groupMonitoringData: Map(),
})

export default (groupMonitoringState = new InitialGroupMonitoringState(), _action = {}) => {
    const { type } = _action

    switch (type) {
        case UPDATE_GROUP_MONITORING_REQUEST:
        case INITIALIZE_GROUP_MONITORING_DIALOG: {
            return groupMonitoringState.set('loading', true).set('groupMonitoringData', Map())
        }

        case UPDATE_GROUP_MONITORING_REQUEST_SUCCESS: {
            return groupMonitoringState.set('loading', false)
        }

        case GROUP_MONITORING_DATA_REQUEST_SUCCESS: {
            const groupMonitoringData = _.get(_action, 'payload.response.body', {})

            return groupMonitoringState
                .set('loading', false)
                .set('groupMonitoringData', Map({ ...groupMonitoringData }))
        }

        default:
            return groupMonitoringState
    }
}
